<mat-form-field class="w-full">
    <input type="text" [placeholder]="placeholder" aria-label="Select Users" matInput [matAutocomplete]="auto" [formControl]="inputControl" #dataInput appUppercaseInput  >
    <button matSuffix mat-icon-button aria-label="Clear" (click)="onClear($event)">
        <mat-icon>close</mat-icon>
    </button>
    <mat-hint>Selected: {{selectedDatas?.length}}</mat-hint>
</mat-form-field>

<ng-container *ngIf="!endpoint; else asyncOptions">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        <mat-option *ngFor="let data of filteredDatas" [value]="selectedDatas">
            <div (click)="optionClicked($event, data)">
                <mat-checkbox [checked]="data.selected" (change)="toggleSelection(data)" (click)="$event.stopPropagation()">
                    {{ data.value }}
                </mat-checkbox>
            </div>
        </mat-option>
    </mat-autocomplete>
</ng-container>

<ng-template #asyncOptions>
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFnV2">
        <mat-option *ngFor="let data of filteredOptions | async" [value]="selectedDatas">
            <div (click)="optionClickedV2($event, data)">
                <mat-checkbox [checked]="data.selected" (change)="toggleSelectionV2(data)" (click)="$event.stopPropagation();">
                    {{ data[keyValue] }}
                </mat-checkbox>
            </div>
        </mat-option>
    </mat-autocomplete>
</ng-template>
